module.exports = __webpack_public_path__ + "img/Row3Box1.330d7e72.svg";